"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var SHELL_EVENT_OBJECT = 'transport';
var transport = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.chrome) === null || _a === void 0 ? void 0 : _a.webview;
var events = new eventemitter3_1.default();
var ShellEventType;
(function (ShellEventType) {
    ShellEventType[ShellEventType["SIGNAL"] = 1] = "SIGNAL";
    ShellEventType[ShellEventType["INVOKE_METHOD"] = 6] = "INVOKE_METHOD";
})(ShellEventType || (ShellEventType = {}));
var createId = function () { return Math.floor(Math.random() * 9999) + 1; };
var useShell = function () {
    var _a = (0, react_1.useState)(false), windowClosed = _a[0], setWindowClosed = _a[1];
    var _b = (0, react_1.useState)(false), windowHidden = _b[0], setWindowHidden = _b[1];
    var on = function (name, listener) {
        events.on(name, listener);
    };
    var off = function (name, listener) {
        events.off(name, listener);
    };
    var send = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        try {
            transport === null || transport === void 0 ? void 0 : transport.postMessage(JSON.stringify({
                id: createId(),
                type: ShellEventType.INVOKE_METHOD,
                object: SHELL_EVENT_OBJECT,
                method: 'onEvent',
                args: __spreadArray([method], args, true),
            }));
        }
        catch (e) {
            console.error('Shell', 'Failed to send event', e);
        }
    };
    (0, react_1.useEffect)(function () {
        var onWindowVisibilityChanged = function (data) {
            setWindowClosed(data.visible === false && data.visibility === 0);
        };
        var onWindowStateChanged = function (data) {
            setWindowHidden(data.state === 9);
        };
        on('win-visibility-changed', onWindowVisibilityChanged);
        on('win-state-changed', onWindowStateChanged);
        return function () {
            off('win-visibility-changed', onWindowVisibilityChanged);
            off('win-state-changed', onWindowStateChanged);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (!transport)
            return;
        var onMessage = function (_a) {
            var data = _a.data;
            try {
                var _b = JSON.parse(data), type = _b.type, args = _b.args;
                if (type === ShellEventType.SIGNAL) {
                    var methodName = args[0], methodArg = args[1];
                    events.emit(methodName, methodArg);
                }
            }
            catch (e) {
                console.error('Shell', 'Failed to handle event', e);
            }
        };
        transport.addEventListener('message', onMessage);
        return function () { return transport.removeEventListener('message', onMessage); };
    }, []);
    return {
        active: !!transport,
        send: send,
        on: on,
        off: off,
        windowClosed: windowClosed,
        windowHidden: windowHidden,
    };
};
exports.default = useShell;
